import Clipboard from 'clipboard'
import { Component } from 'react'
import EditButton from 'shared/containers/edit-button'
import { removeAllQueryParams } from 'shared/util/url-utils'
import Favorite from '../../components/favorite/favorite'
import { getShareUrl } from '../../util/gif-extract'
import css from './gif-menu.css'

const SUCCESS_MESSAGE = 'Link copied to clipboard!',
    ERROR_MESSAGE = 'Error copying to clipboard :('

const showClipboard = Clipboard.isSupported()

/**
 * GIF Grid - Favorite: Favorite GIFs in the GIF grid!
 *
 * @class Favorite
 */
export default class GifMenu extends Component {
    createClipboard() {
        const {
            gif: {
                images: {
                    original: { url },
                },
            },
        } = this.props
        this.clipboard = new Clipboard(this.copyButton, { text: () => removeAllQueryParams(getShareUrl(url)) })
        this.clipboard.on('success', () => {
            window.showSuccess(SUCCESS_MESSAGE)
        })
        this.clipboard.on('error', () => window.showError(ERROR_MESSAGE))
    }
    destroyClipboard() {
        if (this.clipboard) {
            this.clipboard.destroy()
        }
    }
    componentWillUnmount() {
        this.destroyClipboard()
    }
    render() {
        const {
            gif: {
                id,
                images: {
                    original: { url },
                },
                slug,
                url: gifUrl,
                is_favorite: isFavorite = false, // this seemed to be unset somehow
            },
            className,
        } = this.props
        return (
            <div className={className || css.container}>
                <Favorite id={id} url={gifUrl} isFavorite={isFavorite} />
                {showClipboard && (
                    <a
                        ref={(c) => (this.copyButton = c)}
                        onMouseOver={() => this.createClipboard()}
                        onMouseOut={() => this.destroyClipboard()}
                        className={css.link}
                        href={removeAllQueryParams(url)}
                        onClick={(e) => e.preventDefault()}
                    />
                )}
                <EditButton slug={slug} gif={this.props.gif} />
            </div>
        )
    }
}
